import React, { useState } from 'react';
import { QueryFormComponent } from '../../component';
import { toast } from 'react-toastify';

interface FormData {
  name: string;
  email: string;
  subject: string;
  message: string;
}

const QueryForm: React.FC = () => {
  const [formData, setFormData] = useState<FormData>({
    name: '',
    email: '',
    subject: '',
    message: ''
  });

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    console.log('Form submitted:', formData);
    toast.success("Request Submitted");
    // alert('Query submitted successfully!');
    setFormData({ name: '', email: '', subject: '', message: '' });
  };

  return (
    <QueryFormComponent
      formData={formData}
      onChange={handleChange}
      onSubmit={handleSubmit}
    />
  );
};

export default QueryForm;
